export default {
    timeout: 10 * 1000,
    host: 'https://jk.6daa563.xyz/',
    // host: 'https://uat-api.15a7132.com/', // uat
    webKey: 'luckygogointch-intech',
    endPoint: 'H5'
  }
